import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { ClientDetailsResponse } from '@shared/api/clientDetail.api.ts';
import { getApiClientDetails } from '@shared/api/clientDetail.api.ts';
import { extractError } from '@utils/slice.ts';

interface ClientStatusSlice {
    isLoading: boolean;
    error: Record<string, any> | null;
    clientDetails: ClientDetailsResponse | null;
}

const initialState: ClientStatusSlice = {
    isLoading: false,
    error: null,
    clientDetails: null,
};

export const getClientDetails = createAsyncThunk<ClientDetailsResponse, void, { rejectValue: any }>(
    'client/getClientDetails',
    (_, { rejectWithValue }) =>
        getApiClientDetails()
            .then((res) => res)
            .catch((err) => rejectWithValue(err)),
);

const clientDetailsSlice = createSlice({
    name: 'client',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getClientDetails.fulfilled, (state, action) => {
            state.clientDetails = action.payload;
        });
        builder.addCase(getClientDetails.pending, (state) => {
            state.error = null;
            state.isLoading = true;
        });
        builder.addCase(getClientDetails.rejected, (state, action) => {
            state.isLoading = false;
            state.error = extractError(action);
        });
    },
});

export default clientDetailsSlice.reducer;
